// extracted by mini-css-extract-plugin
module.exports = {"ClosedTableMessage":"styles_ClosedTableMessage__OJ8PF"};